const mediaItems = [
  {
    id: 1,
    title: '某顶流明星恋情疑似曝光，网友炸锅热议',
    duration: '03:25',
    views: '128.6万',
    imageUrl: 'https://readdy.ai/api/search-image?query=Entertainment%20news%20thumbnail%20style%20illustration%20with%20abstract%20red%20carpet%20and%20spotlight%20elements%2C%20warm%20coral%20and%20gold%20tones%2C%20minimalist%20design%20with%20geometric%20shapes%2C%20modern%20digital%20media%20banner%20style%2C%20clean%20composition&width=400&height=250&seq=media-card-01&orientation=landscape',
    tag: '娱乐圈',
  },
  {
    id: 2,
    title: '综艺节目录制现场突发状况，笑翻全场观众',
    duration: '05:18',
    views: '96.3万',
    imageUrl: 'https://readdy.ai/api/search-image?query=Variety%20show%20stage%20abstract%20illustration%20with%20colorful%20lights%20and%20dynamic%20shapes%2C%20warm%20orange%20and%20pink%20gradients%2C%20playful%20modern%20design%2C%20entertainment%20media%20thumbnail%20aesthetic%2C%20clean%20minimal%20background&width=400&height=250&seq=media-card-02&orientation=landscape',
    tag: '综艺',
  },
  {
    id: 3,
    title: '热播剧大结局引发全网讨论，编剧回应争议',
    duration: '08:42',
    views: '215.7万',
    imageUrl: 'https://readdy.ai/api/search-image?query=Drama%20series%20finale%20themed%20abstract%20illustration%20with%20film%20reel%20and%20script%20motifs%2C%20warm%20amber%20and%20deep%20coral%20color%20palette%2C%20cinematic%20geometric%20composition%2C%20modern%20clean%20design%20with%20soft%20gradients&width=400&height=250&seq=media-card-03&orientation=landscape',
    tag: '热剧',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            热门视频速递
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-[500px] mx-auto">
            最新鲜的娱乐资讯视频，一键掌握吃瓜动态
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {mediaItems.map((item) => (
            <article key={item.id} className="group rounded-lg overflow-hidden bg-background-50 border border-background-200/60 transition-all duration-300 hover:border-primary-200 cursor-pointer">
              <div className="relative overflow-hidden">
                <img
                  src={item.imageUrl}
                  alt={item.title}
                  className="w-full aspect-video object-cover transition-transform duration-500 group-hover:scale-105"
                  width="400"
                  height="250"
                />
                <div className="absolute bottom-2 right-2 bg-foreground-950/75 text-background-50 text-xs px-2 py-0.5 rounded">
                  {item.duration}
                </div>
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-12 h-12 rounded-full bg-background-50/90 flex items-center justify-center transition-transform duration-300 group-hover:scale-110">
                    <i className="ri-play-fill text-primary-500 text-xl ml-0.5"></i>
                  </div>
                </div>
              </div>
              <div className="p-4">
                <span className="inline-block text-xs font-medium text-primary-500 bg-primary-50 px-2 py-0.5 rounded mb-2">
                  {item.tag}
                </span>
                <h3 className="text-sm md:text-base font-bold text-foreground-900 mb-2 line-clamp-2 leading-snug">
                  {item.title}
                </h3>
                <span className="text-xs text-foreground-400">
                  <i className="ri-eye-line mr-1"></i>
                  {item.views} 次观看
                </span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}